import { identify, makeRequest, Service } from '../../../utils/http';

export async function getAllWarehousesApi() {
  return makeRequest(Service.getAllWarehouses(99999, 0, await identify()));
}
